import React from 'react';
import { t } from '../i18n';
import favoritesBrowseCover from '../assets/note-covers/library-favorites-cover.webp';
import marketBrowseCover from '../assets/note-covers/library-market-cover.svg';
import LibraryGroupImage from './LibraryGroupImage';

export default function LibraryBrowseGroupCard({ group, locale, onOpen }) {
  const market = group.source === 'market';
  const favorites = group.source === 'favorites';
  const title = favorites ? t('library.favorites') : market ? t('library.market') : group.title;
  const description = favorites ? t('library.favoritesIntro') : market ? t('library.marketIntro') : group.description;
  return (
    <button
      type="button"
      className={`library-browse-group-card${market ? ' is-market' : ''}${favorites ? ' is-favorites' : ''}`}
      onClick={() => onOpen(group)}
      aria-label={t(favorites ? 'library.openFavoritesGroup' : 'library.openGroup', undefined, { title })}
    >
      <span className="library-browse-group-image-wrap">
        {favorites ? (
          <img
            src={favoritesBrowseCover}
            alt=""
            className="library-group-image"
            loading="lazy"
            decoding="async"
          />
        ) : market ? (
          <img
            src={marketBrowseCover}
            alt=""
            className="library-group-image"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <LibraryGroupImage
            locale={locale}
            groupId={group.id}
            hasImage={Boolean(group.imageUrl && !group.fallbackPresetId)}
            fallbackPresetId={group.fallbackPresetId}
            fallbackHasCover={group.fallbackHasCover}
            alt=""
          />
        )}
      </span>
      <span className="library-browse-group-copy">
        <strong className="library-browse-group-title">{title}</strong>
        <span className="library-browse-group-description">{description}</span>
      </span>
    </button>
  );
}
